module.exports = __webpack_public_path__ + "static/img/ex_logo_03.7cee0db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ex/ex_logo_03.jpg
// module id = Eh4Z
// module chunks = 0